module.exports = __webpack_public_path__ + "media/stylesheets/images/talentz/bg_example@sp-c130e045b0ae32b23b1b9d491ff949b1.png";